import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { TranscriptionService } from './transcription.service';

export const transcriptionServiceModule = angular.module('transcriptionServiceModule', [])
	.factory('transcriptionService', downgradeInjectable(TranscriptionService))
	.name;
